import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { BreachWallContentWrapper } from './components/BreachWallContentWrapper/BreachWallContentWrapper'
import { BreachWallContentType } from './helpers/BreachWallTypes'

export type BreachScreenRegistrationProps = {
    breachwall?: 'default'
    breachDeal?: string
    /** Breach wall style and package to use from the offers API. Defaults to active feature toggle unless provided. */
    breachType?: BreachWallContentType
    title?: string
    bannerMessage?: string
    message?: string
    terms?: string
    renditionType?: string
    enableSwgCampaign?: boolean
    breachCreativeName?: string
}

export const BreachScreenRegistration = createRegisterableComponent(
    'breachscreen',
    (props: BreachScreenRegistrationProps, services) => {
        return (
            <BreachWallContentWrapper
                {...props}
                requiredAccess={'subscriber'}
                location={services.location}
                onEvent={services.onEvent}
                log={services.log}
            />
        )
    },
)
